<template>
  <div
    v-if="loading"
    class="content"
  >
    <div class="loading">
      <div class="loader" />
    </div>
  </div>
  <div
    v-else
    class="content"
  >
    <div class="md-layout">
      <!-- <div class="md-layout-item md-medium-size-100 md-size-100">
        <entity-card> </entity-card>
      </div> -->


      <div class="md-layout-item md-medium-size-100 md-size-100">
        <form>
          <md-card>
            <md-card-header data-background-color="green">
              <h4 class="title">
                #{{ item.name }}
              </h4>
              <!-- <p class="category" v-if="this.user.glpiactiveprofile!='Leitura'">Preencha com a solução</p> -->
            </md-card-header>


            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Nome</label>
                    <md-input v-model="item.name" />
                  </md-field>
                </div>



                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field>
                    <label>Tipo</label>
                    <md-select
                      id="type"
                      v-model="item.type"
                      name="type"
                    >
                      <md-option
                        v-for="type in types"
                        :key="type.id"
                        :value="type.id"
                      >
                        {{ type.name }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>




                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Fabricante</label>
                    <!-- <md-input v-model="item.fab" disabled></md-input> -->
                    <md-select
                      id="manufacturer"
                      v-model="item.fab"
                      name="manufacturer"
                    >
                      <md-option
                        v-for="type in manufacturers"
                        :key="type.id"
                        :value="type.id"
                      >
                        {{ type.name }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Fornecedor</label>
                    <md-input v-model="item.supplier" />
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Unidade</label>
                    <md-input v-model="item.unity" />
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Localização</label>
                    <!-- <md-input v-model="item.location" disabled></md-input> -->
                    <md-select
                      id="location"
                      v-model="item.location"
                      name="location"
                    >
                      <md-option
                        v-for="type in locations"
                        :key="type.id"
                        :value="type.id"
                      >
                        {{ type.name }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>

                <!-- <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Data de Inventário</label>
                    <md-input type="datetime-local"  v-model="item.date"></md-input>
                  </md-field>
                </div> -->

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Especificação técnica</label>
                    <md-input v-model="item.ref" />
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Valor unitário (R$)</label>
                    <!-- <md-input v-model="item.value" ></md-input> -->
                    <md-input
                      v-model="item.value"
                      type="number"
                    />
                  </md-field>
                </div>



                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Leadtime (dias)</label>
                    <!-- <md-input v-model="item.leadtime" ></md-input> -->
                    <md-input
                      v-model="item.leadtime"
                      type="number"
                    />
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Estoque mínimo ({{ this.item.unity }})</label>
                    <md-input
                      v-model="item.min"
                      type="number"
                    />
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-50 md-size-50">
                  <md-field maxlength="5">
                    <label>Opção de Cálculo automático</label>
                    <md-select
                      id="movie"
                      v-model="item.auto"
                      name="movie"
                    >
                      <md-option value="1">
                        ATIVADO
                      </md-option>
                      <md-option value="0">
                        DESATIVADO
                      </md-option>
                    </md-select>
                  </md-field>
                </div>

                <!-- <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field maxlength="5">
                    <label>Comentário</label>
                    <md-input v-model="item.comment" ></md-input>
                  </md-field>
                </div> -->




                <div
                  v-if="this.user.glpiactiveprofile!='Leitura'"
                  class="md-layout-item md-size-100 text-right"
                >
                  <md-button
                    class="md-raised md-success"
                    @click="fillData()"
                  >
                    SALVAR
                  </md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { userService } from "../_services";
import VueApexCharts from "vue-apexcharts";

import { getUserSession } from "../_services/localstorage";

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  data() {
    return {
      id: 0,
      glpiActiveEntity:0,
      loading: true,
      item:{
        id:0,
        name:"",
        ref:"",
        type:"",
        fab:"",
        used:0,
        new:0,
        location:"",
        min:0,
        comment:"",
        date:"",
        lastYear:0,
        total:0,
        value:0,
        leadtime:0,
        auto:0,
        unity:"PÇ",
        supplier:"",
      },
      consumption:[],
      types:[],
      manufacturers:[],
      locations:[]

    };
  },
  created: function() {
      // this.id = this.$route.params.id;
      this.loading=true;
      this.returnUrl =  "/consumables";
      // console.log(this.id)
      this.user = getUserSession();
      this.glpiActiveEntity=this.user.activeentity;


      userService.getConsumableItemType(this.user.token).then(searchResult => {
        // console.log(searchResult.glpiConsumableItem);
        this.types=searchResult.glpiConsumableItem;
        // console.log(this.types)
      });

      userService.getManufacturer(this.user.token).then(searchResult => {
        // console.log(searchResult.glpiConsumableItem);
        this.manufacturers=searchResult.glpiConsumableItem;
        // console.log(this.manufacturers)
      });

      userService.getLocation(this.user.token).then(searchResult => {
        // console.log(searchResult.glpiConsumableItem);
        this.locations=searchResult.glpiConsumableItem;
        // console.log(this.locations)
      });

      // var now = new Date();

      // this.getInfo();
      this.loading=false;
      this.timer = setInterval(this.checkSite, 1000);


  },
  methods:{
    getInfo(){
      this.loading=true;
      userService.getConsumableItem(this.user.token,this.id ).then(searchResult => {
        // console.log(searchResult);

        this.item=searchResult;
        if(this.item==null){
          this.$router.push(this.returnUrl);
        }
        userService.getConsumableItemInfo(this.user.token,this.id ).then(searchResult => { this.item.date= searchResult;});

        userService.getConsumableList(this.user.token,this.id ).then(searchResult => {
          // console.log(searchResult);

          // console.log(searchResult);
          var j=0,swapdate,swapposition;
          var now = new Date();
          var swapHistoryYear=now.getFullYear()-1-2000;
          now.setFullYear(now.getFullYear()-1);
          // console.log(now.toLocaleDateString())
          // console.log(searchResult)
          this.consumption=Array(12).fill(0);
          var swapMonth2=[],swapMonth=[
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez"
          ];

          for (j = 0; j < searchResult.length; j++) {
            if(searchResult[j].date_out!=null){
              swapdate = new Date(searchResult[j].date_out);
              // console.log(swapdate.toLocaleDateString())
              if(swapdate>now){
                // console.log(swapdate)
                this.item.lastYear=this.item.lastYear+1;
                swapposition=(swapdate.getMonth()-now.getMonth()-1);
                if(swapposition<0){
                  swapposition=swapposition+12;
                }
                this.consumption[swapposition]=this.consumption[swapposition]+1;

              }

            }

          }
          now.setFullYear(now.getFullYear()+1);
          for (j = (now.getMonth()+1); j < now.getMonth()+13; j++) {

            if(j>11){

              swapMonth2.push(swapMonth[j%12]+"/"+(swapHistoryYear+1));
            }
            else{
              swapMonth2.push(swapMonth[j%12]+"/"+(swapHistoryYear));
            }

          }

          console.log(swapMonth2);

          this.apexOptionsTicketsEvolution.xaxis.categories=swapMonth2;

          console.log(this.consumption);
          this.apexSeries3=[{
            name:"Consumo",
            data:this.consumption
          }];
          this.loading=false;
          // console.log(this.item)

        });
      });
    },
    fillData () {

      userService.addConsumable(this.user.token,this.item,this.glpiActiveEntity).then(response => {
        // console.log(response);
        // console.log(response.data.id);
        if(response.data!=null){
          this.returnUrl =  "/consumableinfo/"+response.data.id;
          this.$router.push(this.returnUrl);
        }


        // this.getInfo();
        // this.$router.push(this.returnUrl)
      });


    },
    checkSite: function () {


      // console.log("check "+this.user.activeentity+ " > "+this.glpiActiveEntity)

      this.user = getUserSession();
      // console.log(this.user);
      // this.totalTickets=this.totalTickets+1;

      if(this.user.activeentity!=this.glpiActiveEntity){
        this.glpiActiveEntity=this.user.activeentity;

        this.loading=true;
        // console.log("Search1");
        // this.getInfo();



      }
    },
    convertDate: function (str) {
      var date = new Date(str);
      return date.toLocaleDateString();

    },
  }
};
</script>

<style>

.apexcharts-menu-item.exportSVG {
  display: none;
}

.apexcharts-menu-item.exportPNG {
  display: none;
}


</style>
